<template>
  <div>
    <table style="width: 100%" class="table table-bordered">
      <thead>
        <tr class="text-center">
          <td style="width: 10%">No</td>
          <td style="width: 40%">Kabupaten/Kota</td>
          <td style="width: 20%">Tim Manajemen Dana BOS</td>
          <td style="width: 30%">Ket</td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Baubau</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Bombana</td>
          <td class="text-center">92.31%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Busel</td>
          <td class="text-center">90%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Buteng</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>5</td>
          <td>Buton</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>6</td>
          <td>Butur</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>7</td>
          <td>Kendari</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>8</td>
          <td>Kolaka</td>
          <td class="text-center">40%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>9</td>
          <td>Koltim</td>
          <td class="text-center">0%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>10</td>
          <td>Kolut</td>
          <td class="text-center">90.91%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>11</td>
          <td>Konawe</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>12</td>
          <td>Konkep</td>
          <td class="text-center">85.71%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>13</td>
          <td>Konsel</td>
          <td class="text-center">83.33%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>14</td>
          <td>Konut</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>15</td>
          <td>Mubar</td>
          <td class="text-center">71.43%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>16</td>
          <td>Muna</td>
          <td class="text-center">100%</td>
          <td>-</td>
        </tr>
        <tr>
          <td>17</td>
          <td>Wakatobi</td>
          <td class="text-center">85.51%</td>
          <td>-</td>
        </tr>
        <tr>
          <td colspan="2">Rerata</td>
          <td class="text-center">84.66%</td>
          <td>-</td>
        </tr>
      </tbody>
    </table>
    <div id="tabel_5"></div>
    <div class="text-center h_cetak_1">
      <i>Grafik 5. Data Tim Manajemen Dana BOS</i>
    </div>
    <br>
  </div>
</template>



<script>
const ADD_URL = URL_APP + "api/v1/instrumen_guru/";
import uniqid from "uniqid";

export default {
  name: "monev_instrumen_guru",
  data: function() {
    return {
      ada: "ada"
    };
  },

  methods: {
    tabel_5 : function(){
        var data = google.visualization.arrayToDataTable([
          ['Opening Move', 'Percentage', { role: 'annotation' }],
          ["Baubau", 100, 100],
          ["Bombana", 92.31, 92.31],
          ["Busel", 90, 90],
          ["Buteng", 100, 100],
          ["Buton", 100, 100],
          ["Butur", 100, 100],
          ["Kendari", 100, 100],
          ["Kolaka", 40, 40],
          ["Koltim", 0, 0],
          ["Kolut", 90.91, 90.91],
          ["Konawe", 100, 100],
          ["Konkep", 85.71, 85.71],
          ["Konsel", 83.33, 83.33],
          ["Konut", 100, 100],
          ["Mubar", 71.43, 71.43],
          ["Muna", 100, 100],
          ["Wakatobi", 85.51, 85.51],
      ]);

      var options = {
        title: "SEKOLAH YANG MENGUMUMKAN DANA BOS",
        bar: {groupWidth: '60%'},
        legend: 'none',
        vAxis: {minValue: 0},
        height:350,
        backgroundColor: '#E4E4E4',
      };

      var chart_div = document.getElementById('tabel_5');
      var chart = new google.visualization.ColumnChart(chart_div);

      // Wait for the chart to finish drawing before calling the getImageURI() method.
      google.visualization.events.addListener(chart, 'ready', function () {
        chart_div.innerHTML = '<img src="' + chart.getImageURI() + '">';
        // console.log(chart_div.innerHTML);
      });

      chart.draw(data, options);
    }
  },

  // =============================================================== METHODS =========================================================================

  mounted() {
    google.charts.load("current", { packages: ["corechart"] });
    google.charts.setOnLoadCallback(this.tabel_5);
  }
};
</script>
